// extracted by mini-css-extract-plugin
export default {"container":"notificationDialog_container__jTgYG","content":"notificationDialog_content__RM7nH"};